import Pusher from 'pusher-js'

const pusher = new Pusher('32561c96d460f8297c62', {
    cluster: 'ap1'
});

export const notification = pusher.subscribe('notification')

